"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processBioMutations = processBioMutations;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _rdfMutationHelpers = require("../shared/rdfMutationHelpers");
var _texts = require("../../texts");
// Need to find out if this is really how we should store the data
async function mutateBioEntry(store, subject, bioOps) {
  const doc = subject.doc();
  const deletions = [];
  const insertions = [];
  const replaceLiteralField = (predicate, value) => {
    const normalized = (value || '').trim();
    const nextObject = normalized ? (0, _rdflib.literal)(normalized) : null;
    (0, _rdfMutationHelpers.replacePredicateStatements)(store, subject, predicate, doc, deletions, insertions, nextObject);
  };
  const applyBasics = (bio, clearAll = false) => {
    const data = clearAll ? {
      description: ''
    } : bio;
    replaceLiteralField(_solidUi.ns.vcard('note'), data.description);
  };
  const removeBio = bioOps.remove[0];
  const updateBio = bioOps.update[0];
  const createBio = bioOps.create[0];
  const selectedBio = updateBio || createBio || removeBio;
  if (selectedBio) {
    applyBasics(selectedBio, Boolean(removeBio && !updateBio && !createBio));
  }
  await (0, _rdfMutationHelpers.applyUpdaterPatch)(store, deletions, insertions);
}
async function processBioMutations(store, subject, mutationPlan) {
  try {
    await mutateBioEntry(store, subject, mutationPlan);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`${_texts.saveBioUpdatesFailedPrefixText} ${message}`);
  }
}